export default __webpack_public_path__ + "static/media/qr_appstore_okara.a83c3c0f.svg";